import React from "react";
import { Section, Reveal, Eyebrow, SectionTitle, CTAButton } from "./ui";
import { tomos, educationalDisclaimer } from "./data";
export function Tomos() {
  return <Section id="tomos" className="bg-white" data-id="element-210" data-mp="139v1aq38grdd">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-211" data-mp="1h44c59ihhfnv">
        <Eyebrow data-id="element-212" data-mp="1cce1f2fmwpvx">Módulos de intervención cotidiana</Eyebrow>
        <SectionTitle data-id="element-213" data-mp="1cat6vctbl6y2">6 guías con estrategias concretas para cada momento difícil.</SectionTitle>
        <p className="mt-4 text-sm leading-relaxed text-[var(--muted)] sm:text-base" data-id="element-214" data-mp="1qzpbezw641tx">
          Cada tomo responde a un frente distinto del día a día, para que sepas qué probar
          cuando lo que venías haciendo ya no funciona.
        </p>
      </Reveal>

      <div className="mt-8 grid gap-2.5 sm:mt-10 sm:grid-cols-2 sm:gap-4 lg:grid-cols-3" data-id="element-215" data-mp="1vztu8wkjt8nb">
        {tomos.map((t, i) => <Reveal key={t.n} delay={i % 3 * 0.05} data-id="element-216" data-mp="5op67g8ardgm" data-mpi={i}>
            <article className="flex h-full gap-3 rounded-2xl border border-[#e6eef5] bg-white p-3 text-left shadow-[0_14px_36px_-28px_rgba(23,50,77,0.6)] sm:flex-col sm:gap-0 sm:p-5" data-id="element-217" data-mp="1mc2syh0vrn0">
              <img src={t.img} alt={`Tomo ${t.n}: ${t.title}`} className="h-28 w-auto flex-none rounded-lg object-contain drop-shadow-md sm:mb-4 sm:h-40 sm:w-full" loading="lazy" data-id="element-218" data-mp="34oviqmqq1fdy" />
              <div className="flex flex-col" data-id="element-219" data-mp="3jge83b5h0m9z">
                <span className="text-[10px] font-extrabold uppercase tracking-[0.14em] text-[var(--accent)]" data-id="element-220" data-mp="3jhfgt8z0kwoj">
                  Tomo {t.n}
                </span>
                <h3 className="mt-0.5 font-serif-display text-base leading-tight text-[var(--ink)] sm:text-lg" data-id="element-221" data-mp="3septmyrhctvk">
                  {t.title}
                </h3>
                <p className="mt-1.5 text-xs leading-snug text-[var(--muted)] sm:text-sm sm:leading-relaxed" data-id="element-222" data-mp="69m6ljf7hojc">
                  {t.desc}
                </p>
              </div>
            </article>
          </Reveal>)}
      </div>

      <Reveal delay={0.1} className="mt-7 text-center sm:mt-9" data-id="element-223" data-mp="280zaq69cnsec">
        <p className="mx-auto max-w-2xl text-[11px] leading-relaxed text-[#8b98a5]" data-id="element-224" data-mp="1zz87p61rx9q6">
          {educationalDisclaimer}
        </p>
        <CTAButton className="mt-6" data-id="element-225" data-mp="1vzqyq2n51ug9">Quiero estas 6 guías de estrategias</CTAButton>
      </Reveal>
    </Section>;
}